import moment from "moment";
import { logData } from "../api/h2o";

export const logDataApi = ({ rsvnNo, progress, ref }: { rsvnNo: string; progress: string; ref: string }) => {
  if (process.env.REACT_APP_ENV === "production" && process.env.REACT_APP_H2O_LOG_YN === "Y") {
    const date = moment().format("YYYYMMDD");
    logData({ hotel: "SA000003", rsvnNo, progress, type: "1", date: date, ref });
  }
};
